import { useSelector } from 'react-redux';
import { hasFeatureEnabled } from '../../../../services/feature';
import {
  selectCurrentMember,
  selectHasCurrentMemberActiveSubscription,
} from '../../../../services/store/modules/backend-service';
import {
  EXTENDED_FORECAST_DAYS,
  FREE_FORECAST_DAYS,
} from '../helpers/forecastHorizon';

export const useExtendedWeatherForecast = () => {
  const isExtendedWeatherForecastEnabled = Boolean(
    hasFeatureEnabled('extended-weather-forecast'),
  );
  const currentMember = useSelector(selectCurrentMember);
  const hasActiveSubscription = Boolean(
    useSelector(selectHasCurrentMemberActiveSubscription),
  );
  const forecastDaysRequested =
    isExtendedWeatherForecastEnabled && hasActiveSubscription
      ? EXTENDED_FORECAST_DAYS
      : FREE_FORECAST_DAYS;
  const showNonSubscriberCtas =
    isExtendedWeatherForecastEnabled &&
    Boolean(currentMember) &&
    !hasActiveSubscription;

  return {
    isExtendedWeatherForecastEnabled,
    hasActiveSubscription,
    forecastDaysRequested,
    showNonSubscriberCtas,
  };
};
